import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  input,
  output
} from "@angular/core";
import { IconService } from "src/app/services/icon.service";

import { IconComponent } from "../icon/icon.component";

@Component({
  selector: "app-section-toggler",
  templateUrl: "./section-toggler.component.html",
  imports: [IconComponent],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SectionTogglerComponent implements OnInit {
  icon = input<string | undefined>();
  title = input.required<string>();
  isCollapsed = input.required<boolean>();
  disableToggle = input<boolean>(false);
  toggle$ = output<void>();

  constructor(public iconService: IconService) {}

  ngOnInit(): void {}

  onToggle(): void {
    this.toggle$.emit();
  }
}
